var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function () {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function (selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " + extraClasses + "'></div>");
	}
}


site.owl = {
	// Shorthand to init owlcarousel
	init: function (id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};


site.icon = {
	init: function () {
		$('.icon.svg').each(function() {
			let icon = $(this).data('icon');
			if (icon && icon.length) {
				let style = "url('/static/files/icons/" + icon + ".svg') no-repeat center / contain;";
				$(this).attr('style', "background: " + style);
			}
		});
	}
};

site.frontpage = {
	init: function () {
		if (!$('body').hasClass('frontpage')) return false;

		/*var $searchBox = $('#searchBox');
		$searchBox.responsiveDom({
			appendTo: 'nav',
			mediaQuery: 'screen and (max-width: 991px)',
		});*/

		//$searchBox.addClass('js-complete');

		site.frontpage.carouselHeightFix();
		$(window).load(function () {
			site.frontpage.carouselHeightFix();
		});
		$(window).resize(function () {
			site.frontpage.carouselHeightFix();
		});

		site.owl.init('.box.service .carousel .wrap', {
			loop: false,
			dots: true,
			nav: false,
			items: 1
		});

		$('a.more','#box_group_3').wrap('<div class="footer" />');
	},

	carouselHeightFix: function () {
		var carouselHeight = $('.box.service .carousel').height();
		$('.image > a', '.box.service').css('min-height', carouselHeight);
	}
};

site.service = {
	init: function () {
		$('#itemFilter').change(function () {
			var val = $(this).find("option:selected").val();
			var scrollTop = $(window).scrollTop();
			location.hash = val;
			window.scrollTo(0, scrollTop);
		});

		$(window).load(function () {
			var $container = $('#extras .items');
			$container.isotope({
				// options
				itemSelector: '.item',
				layoutMode: 'vertical',
				hiddenStyle: {
					opacity: 0
				},
				visibleStyle: {
					opacity: 1
				}
			});

			$container.addClass('loaded');
		});

		$(function () {
			$(window).bind("hashchange", function (e) {
				var b = location.hash;
				b = (b == '') ? '#all' : b;

				if (b) {
					b = b.substr(1, b.length);
					var filterValue = (b == 'all') ? '*' : '.' + b;
					var $container = $('#extras .items');
					$container.isotope({filter: filterValue});
					$('.categories li').removeClass('selected');
					$(".categories ." + b).addClass('selected');
					$("#itemFilter ." + b).attr('selected', 'selected');
				}
			});
			$(window).trigger("hashchange");
		});

		site.maxHeight.init('.item .description');

		$('a.toggleDetails').on('click touchStart', function(e) {
			e.preventDefault();
			$(this).parents('.item').toggleClass('open');
			setTimeout(function() {
				$('#extras .items').isotope( 'layout' );
			},400);
		});
	}
};

// Run all the inits \o/
$(function () {
	$.each(site.inits, function (i, value) {
		var fun = new Function(value);
		fun();
	});

	site.toggle.init('#searchToggle', '#searchBox', 'search');
	site.icon.init();
	site.megamenu.init();
	site.frontpage.init();

	site.owl.init('#hero ul', {
		loop: true,
		dots: true,
		nav: false,
		items: 1,
		stopOnHover: true,
		autoplay: true,
		autoplayTimeout: 8000,
		autoplayHoverPause: true
	});

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function () {
		$(this).attr('allowfullscreen', '').wrap('<div class="video" style="max-width:' + $(this).width() + 'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$('body').is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Touch login
	$('.login').dblclick(function (e) {
		e.preventDefault();
		window.location = '/moya';
	});

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);

	$('li', '#footerInfo').each(function () {
		var bc = $(this);
		bc.html(bc.html().replace(/\|/g, '<span class=\"slash\">/</span>'));
	});
});
